export enum MethodsOfPayment {
    CASH = 0,
    TRANSFER = 1    
}